import React, { useState } from 'react';

const CreateNotice = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: 'General',
    priority: 'Normal',
    file: null
  });

  const handleChange = (e) => {
    if (e.target.name === 'file') {
      setFormData({
        ...formData,
        file: e.target.files[0]
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would submit to an API
    console.log('Notice created:', formData);
    alert('Notice created successfully!');
    setFormData({
      title: '',
      description: '',
      category: 'General',
      priority: 'Normal',
      file: null
    });
  };

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Create New Notice</h1>
        
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label htmlFor="title" className="block text-gray-700 mb-2">Title *</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                className="w-full p-2 border rounded"
                placeholder="Enter notice title"
              />
            </div>
            
            <div className="mb-6">
              <label htmlFor="description" className="block text-gray-700 mb-2">Description *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                rows="5"
                className="w-full p-2 border rounded"
                placeholder="Enter notice description"
              ></textarea>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="category" className="block text-gray-700 mb-2">Category *</label>
                <select
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                >
                  <option value="Academic">Academic</option>
                  <option value="Admission">Admission</option>
                  <option value="Exam">Exam</option>
                  <option value="General">General</option>
                  <option value="Events">Events</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="priority" className="block text-gray-700 mb-2">Priority *</label>
                <select
                  id="priority"
                  name="priority"
                  value={formData.priority}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                >
                  <option value="Normal">Normal</option>
                  <option value="Important">Important</option>
                  <option value="Urgent">Urgent</option>
                </select>
              </div>
            </div>
            
            <div className="mb-6">
              <label htmlFor="file" className="block text-gray-700 mb-2">Attachment (Optional)</label>
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleChange}
                className="w-full p-2 border rounded"
              />
            </div>
            
            <div className="flex justify-end space-x-4">
              <a href="/admin/notices" className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition">
                Cancel
              </a>
              <button
                type="submit"
                className="bg-primary text-white px-6 py-2 rounded hover:bg-blue-700 transition"
              >
                Publish Notice
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateNotice;